import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
  Form,
  Modal,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Pagi2 from "common/utils/Pagi2";
import { CommonTableContainer } from "common/utils/ComonTableContainer";
import "../../common/styles/proposal.css";
import Swal from "sweetalert2";
import DemoPdf from "../../assets/PDF/blank.pdf";
import Loader from "components/Common/Loader";
import AccessDeniedPopup from "components/Common/AccessDeniedPopup";
import axios from "axios";
import configure from "configure";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import ProposalPdf from "./View-proposal";
import Pagination from "common/utils/Pagination";
import { customGlobalFilter } from "utils/common-helpers";

const ProposalIndex = () => {
  const [fixedContent, setFixedContent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [formPopup, setFormPopup] = useState(false);

  useEffect(() => {
    fetchProposal();
  }, []);

  const fetchProposal = async () => {
    setLoading(true);
    const authUser = secureLocalStorage.getItem("Token");
    try {
      const res = await axios({
        method: "get",
        url: `${configure.apiUrl}/proposals`,
        // data: formData,
        headers: {
          Authorization: `Bearer ${authUser}`,
        },
      }).then((res) => {
        setData(res.data.proposals);
        setLoading(false);
      });
    } catch (error) {
      console.log("Fetch Proposal Error", error);
      setLoading(false);
    }
  };

  document.title = "Proposal | Zithas Technologies";

  const navigate = useNavigate();

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true);
    } else {
      setFixedContent(false);
    }
  });

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "proposal_id",
        isInfoIcon: false,
        isShortIcon: true,
        className: "proposal_id text-center",
        Cell: (cellProps) => {
          return <div className="text-center">{cellProps.row.original.id}</div>;
        },
      },

      {
        Header: "Proposal Title",
        accessor: "proposal_name",
        isInfoIcon: false,
        isShortIcon: true,
        className: "proposal_name",
        Cell: (cellProps) => {
          return (
            <div className="">
              {cellProps.row.original.proposaltitile || "-"}
            </div>
          );
        },
      },
      {
        Header: "Client Name",
        accessor: "companyname",
        isInfoIcon: false,
        isShortIcon: true,
        className: "proposal_name",
        Cell: (cellProps) => {
          return (
            <div className="">
              {cellProps.row.original.companyname || "-"}
            </div>
          );
        },
      },

      {
        Header: "Type",
        accessor: "proposal_type",
        isInfoIcon: false,
        isShortIcon: true,
        className: "proposal_type",
        Cell: (cellProps) => {
          const rowIndex = cellProps.row.index;
          return (
            <div className="">
              <div className="pt-1 ms-2">
                {cellProps.row.original.type || "-"}
              </div>
            </div>
          );
        },
      },

      {
        Header: "Price",
        accessor: "proposal_price",
        isInfoIcon: false,
        isShortIcon: true,
        className: "proposal_price",
        Cell: (cellProps) => {
          const array = JSON.parse(cellProps.row.original?.costbreakdown);
          const totalSum = array?.reduce((accumulator, item) => {
            const totalValue = parseFloat(item.totalcost);
            if (!isNaN(totalValue)) {
              return accumulator + totalValue;
            }
            return accumulator;
          }, 0);
          return (
            <div className="">
              {cellProps?.row?.original?.currency_symbol} {totalSum || 0}
            </div>
          );
        },
      },
      {
        Header: "Created At",
        accessor: "created_at",
        isInfoIcon: false,
        isShortIcon: true,
        className: "created_at",
        Cell: (cellProps) => {
          return (
            <div className="">
              {moment(cellProps.row.original?.created_at.slice(0, 10)).format(
                "DD-MM-YYYY"
              )}
            </div>
          );
        },
      },
      {
        Header: "Commission",
        accessor: "commission",
        isInfoIcon: false,
        isShortIcon: true,
        className: "open_till",
        Cell: (cellProps) => {
          const array = JSON.parse(cellProps.row.original?.costbreakdown);
          const totalSum = array?.reduce((accumulator, item) => {
            const totalValue = parseFloat(item.totalcost);
            if (!isNaN(totalValue)) {
              return accumulator + totalValue;
            }
            return accumulator;
          }, 0);

          let commission = 0
          if (cellProps.row.original?.commissionstructure == "percentage") {
            commission = (cellProps.row.original?.percentage / 100) * totalSum
          } else {
            commission = cellProps.row.original?.percentage
          }

          return (
            <div className="">
              {cellProps?.row?.original?.currency_symbol} {commission
                ? commission
                : "0"}
            </div>
          );
        },
      },

      {
        Header: "Action",
        accessor: "action",
        className: "proposal_action",
        isInfoIcon: false,
        Cell: (cellProps) => {
          return (
            <>
              <div className="d-flex justify-content-center">
                {/* <a
                  className="btn btn-sm btn-outline-secondary me-1"
                  title="Download"
                  href={DemoPdf}
                  target="_blank"
                  rel="noreferrer"
                  download
                >
                  <i className="fas fa-download "></i>
                </a> */}
                <ProposalPdf proposal_id={cellProps.row.original.id} />
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      globalFilter: customGlobalFilter,
      initialState: {
        pageIndex: 0,
        sortBy: [{ id: "id", desc: true }],
      },
    },
    useGlobalFilter,
    usePagination
  )


  const { pageIndex, pageSize, globalFilter } = state;
  useEffect(() => setPageSize(50), []);

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Proposal"} />
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <div>
                      {/* fixed buttons */}
                      <div
                        className={`flex-column fixed-buttons pt-2 ${fixedContent ? "d-flex" : "d-none"
                          }`}
                      >
                        {/* <Link
                         to="/add_proposal" 
                         className=" btn ms-md-2 btn-save btn-label">
                            <i className="fas fa-plus me-1 label-icon"></i> Proposal
                        </Link>     */}
                        <button
                          onClick={() => navigate(-1)}
                          className="btn btn-red  fix-btn btn-label"
                        >
                          <i className="dripicons-cross me-2 icon-center label-icon"></i>
                          <span>Cancel</span>
                        </button>
                      </div>
                      <Row className="mb-2">
                        <Col className="col-2">
                          <select
                            className=" me-4 form-select"
                            style={{ width: "100px" }}
                            value={pageSize}
                            onChange={(e) => setPageSize(e.target.value)}
                          >
                            {[10, 25, 50, 100].map((pageSize) => (
                              <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                              </option>
                            ))}
                          </select>
                        </Col>
                        <Col className="col-10 d-flex justify-content-end">
                          <div className="me-3">
                            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
                              <div className="position-relative">
                                <label
                                  htmlFor="search-bar-0"
                                  className="search-label"
                                >
                                  <span
                                    id="search-bar-0-label"
                                    className="sr-only"
                                  >
                                    Search this table
                                  </span>
                                  <input
                                    onChange={(e) =>
                                      setGlobalFilter(e.target.value)
                                    }
                                    id="search-bar-0"
                                    type="text"
                                    className=" form-control rounded h-100"
                                    placeholder={`Search...`}
                                    value={globalFilter || ""}
                                  />
                                </label>
                                <i className="bx bx-search-alt search-icon"></i>
                              </div>
                            </div>
                          </div>

                          <div className="text-md-end">
                            {/* <Link
                             to="/add_proposal" 
                             className=" btn ms-md-2 btn-save  btn-label me-2">
                                <i className="fas fa-plus me-1 label-icon"></i> Proposal
                            </Link>  */}
                            <button
                              onClick={() => navigate(-1)}
                              className=" btn btn-red btn-label"
                            >
                              <i className="dripicons-cross me-2  lab label-icon"></i>
                              CANCEL
                            </button>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <div className="col-12">
                          <div className="position-relative shadow">
                            <table
                              className="table table-bordered mt-4"
                              {...getTableProps()}
                            >
                              <thead
                                className={`${fixedContent ? "fix-header" : ""
                                  } fix-lead-header`}
                              >
                                {headerGroups.map((headerGroup, i) => (
                                  <tr
                                    key={i}
                                    {...headerGroup.getHeaderGroupProps()}
                                  >
                                    {headerGroup.headers.map((column, index) => (
                                      <th
                                        key={index}
                                        className={`t-col-${index + 1} ${column.className
                                          }`}
                                        {...column.getHeaderProps()}
                                      >
                                        {column.render("Header")}
                                      </th>
                                    ))}
                                  </tr>
                                ))}
                              </thead>

                              <tbody
                                className="fix-lead-header"
                                {...getTableBodyProps()}
                              >
                                {page.map((row, i) => {
                                  prepareRow(row)
                                  let backColor
                                  if (row.original.lead_type == "Hot") {
                                    backColor = "bd-hot"
                                  }
                                  return (
                                    <tr
                                      className={`row-hover ${backColor}`}
                                      {...row.getRowProps()}
                                      key={i}
                                    >
                                      {row.cells.map((cell, index) => {
                                        return (
                                          <td
                                            key={index}

                                            className={`t-col-${index + 1} ${cell.column.className
                                              }`}
                                            {...cell.getCellProps()}
                                          >
                                            {cell.render("Cell")}
                                          </td>
                                        )
                                      })}
                                    </tr>
                                  )
                                })}
                                {page.length == 0 ? (
                                  <tr>
                                    <td className="text-center" colSpan={10}>
                                      No Leads Available
                                    </td>
                                  </tr>
                                ) : null}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Row>

                      {/* Pagination */}
                      <Row className="justify-content-md-end justify-content-center align-items-center">
                        <Pagination
                          gotoPage={gotoPage}
                          previousPage={previousPage}
                          canPreviousPage={canPreviousPage}
                          nextPage={nextPage}
                          canNextPage={canNextPage}
                          pageIndex={pageIndex}
                          pageOptions={pageOptions}
                        />
                      </Row>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ProposalIndex;
